<template>
  <div class="container">
    <div class="top-title">
      <el-button
        type="text"
        @click="back">
        返回
      </el-button>
      <h4>{{ruleDetaile.ruleName}}</h4>
    </div>

    <div class="top-des">
      <span>描述</span>
      <span>{{ruleDetaile.ruleDescription}}</span>
    </div>
    <div class="block">
      <p>触发器(Trigger)</p>
      <template v-for="(item, index) in triggerList">
        <triger-item
          :product-list="productList"
          :form="item"
          @delete="deleteTriggerItem(index)"
          :key="index"
          :itemIndex="index"
          :title="'触发器'+ (index+1)">
        </triger-item>
      </template>

      <el-button
        type="text"
        @click="addTrigger">
        新增触发器
      </el-button>
    </div>
    <div class="block">
      <p>执行条件(Condition)</p>
      <template v-for="(item, index) in conditionList">
        <condition-item
          :product-list="productList"
          :form="item"
          :key="index"
          :itemIndex="index"
          @deleteItem="deleteConditionItem(index)"
          :title="'执行条件'+ (index+1)">
        </condition-item>
      </template>
      <el-button
        type="text"
        @click="addCondition">
        新增执行条件
      </el-button>
    </div>
    <div class="block">
      <p>执行动作(Action)</p>
      <template v-for="(item, index) in actionList">
        <action-item
          :productList="productList"
          :form="item"
          @deleteItem="deleteAction(index)"
          :key="index"
          :itemIndex="index"
          :title="'执行动作'+ (index+1)">
        </action-item>
      </template>
      <el-button
        type="text"
        @click="addAction">
        新增执行动作
      </el-button>
    </div>
    <el-button
      type="text"
      @click="save">
      保存
    </el-button>
    <el-button
      type="text"
      @click="cancel">
      取消
    </el-button>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { listProduct, editeRule } from '@/api/ruleEngine.js'
import trigerItem from '@/components/ruleEngine/trigerItem.vue'
import conditionItem from '@/components/ruleEngine/conditionItem.vue'
import actionItem from '@/components/ruleEngine/actionItem.vue'

export default {
  name: 'ruleDetaile',
  components: {
    trigerItem,
    conditionItem,
    actionItem
  },
  data () {
    return {
      productList: [],
      showTriggerDetaile: false,
      actionForm: {
        uri: 'action/device/setProperty',
        params: { propertyItems: {} }
      },
      conditionForm: {
        uri: 'condition/device/property',
        params: {}
      },
      triggerList: [{
        uri: '',
        params: { triggerMode: '' }
      }],
      conditionList: [{
        uri: 'condition/device/property',
        params: { conditionType: '' }
      }],
      actionList: [{
        uri: 'action/device/setProperty',
        params: { propertyItems: {} }
      }],
      ruleDetaile: {},
      options1: [{
        value: '1',
        label: '触发设备'
      }, {
        value: '2',
        label: '接收设备'
      }, {
        value: '3',
        label: '中转设备'
      }],
      options2: [{
        value: '选项1',
        label: '空调'
      }, {
        value: '选项2',
        label: '电视'
      }, {
        value: '选项3',
        label: '洗衣机'
      }, {
        value: '选项4',
        label: '冰箱'
      }, {
        value: '选项5',
        label: '扫地机器人'
      }],
      value1: '',
      value2: ''
    }
  },
  mounted () {
    this.ruleDetaile = this.$route.params
    let rulecontent = '{}'
    if (this.ruleDetaile) {
      localStorage.setItem('ruleDetaile', this.ruleDetaile)
      rulecontent = JSON.parse(this.ruleDetaile.ruleContent)
    } else {
      this.ruleDetaile = JSON.parse(localStorage.getItem('ruleDetaile'))
    }
    console.log('rulecontent-----', rulecontent)
    listProduct().then(res => {
      this.productList = res.data
    })
    this.analysisData(rulecontent)
  },
  methods: {
    analysisData (rulecontent) {
      if (!rulecontent) return
      if (rulecontent.action && rulecontent.action.length > 0) {
        this.actionList = rulecontent.action
      }
      if (rulecontent.trigger.items && rulecontent.trigger.items.length > 0) {
        this.triggerList = rulecontent.trigger.items
      }
      if (rulecontent.condition.items && rulecontent.condition.items.length > 0) {
        this.conditionList = rulecontent.condition.items
      }
    },
    deleteTriggerItem (index) {
      debugger
      if (this.triggerList.length > 1) {
        this.triggerList.splice(index, 1)
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      } else if (this.triggerList.length === 1) {
        // this.triggerList.splice(index, 1)
        // this.triggerList.push({
        //   uri: '',
        //   params: { triggerMode: '' }
        // })
        this.$message({
          type: 'error',
          message: '至少保留一个!'
        })
      }
    },
    deleteConditionItem (index) {
      debugger
      if (this.conditionList.length > 1) {
        this.conditionList.splice(index, 1)
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      } else if (this.conditionList.length === 1) {
        // this.conditionList.splice(index, 1)
        // this.conditionList.push({
        //   uri: 'condition/device/property',
        //   params: { conditionType: '' }
        // })
        this.$message({
          type: 'error',
          message: '至少保留一个!'
        })
      }
    },
    deleteAction (index) {
      if (this.actionList.length > 1) {
        this.actionList.splice(index, 1)
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      } else {
        this.$message.error('至少保留一个')
      }
    },
    addCondition (index) {
      this.conditionList.push({
        uri: 'condition/device/property',
        params: { conditionType: '' }
      })
    },
    addTrigger () {
      this.triggerList.push({
        uri: '',
        params: { triggerMode: '' }
      })
    },
    addAction () {
      this.actionList.push(this.actionForm)
      console.log(this.actionForm)
    },
    back () {
      this.$router.back()
    },
    save () {
      const { ruleDetaile } = this
      this.triggerList.forEach(trigerItem => {
        if (trigerItem.params.triggerMode) {
          console.log('有内容')
        }
      })
      let ruleContent = {
        type: 'IFTTT',
        trigger: {
          uri: 'logical/or',
          items: this.triggerList
        },
        condition: {
          uri: 'logical/and',
          items: this.conditionList
        },
        action: this.actionList
      }
      ruleContent = JSON.stringify(ruleContent)
      const params = {
        ruleId: ruleDetaile.ruleId,
        ruleName: ruleDetaile.ruleName,
        ruleDescription: ruleDetaile.ruleDescription,
        ruleContent
      }
      editeRule(params).then(res => {
        this.$message.success('保存成功')
        this.$router.back()
      })
    },
    cancel () {
      console.log('取消')
      this.$router.back()
    }
  }
}
</script>

<style lang="less" scoped>
  .container {
    padding: 0 15px;

    .top-title {
      display: flex;
      flex-direction: row;

      .el-button {
        margin-right: 15px;
      }
    }

    .top-des {
      margin-bottom: 15px;

      & :nth-child(1) {
        margin-right: 10px;
      }
    }

    .block {
      margin-bottom: 10px;

      .el-button {
        padding: 0px;
      }
    }

    /*.top-des :nth-child(1){*/
    /*  color:red;*/
    /*  margin-right: 10px;*/
    /*}*/
  }
</style>
